import { reactive, ref, computed, watch, onMounted } from '@vue/composition-api'
import store from '@/store'
import * as apiCommon from '@/api/common'

/**
 * QA一覧表示設定ウィンドウ
 */
export const getGroup = (props, context) => {
  
  onMounted(() => {

    group1.init_list_per_page_work = store.state.qa.list_per_page
    group1.list_per_page_work = store.state.qa.list_per_page

    const hiddenKeys = store.state.qa.list_hidden_keys
    const displayKeys = []
    for (let i = 0; i < group1.hideableKeys.length; i++) {
      const key = group1.hideableKeys[i]
      if (hiddenKeys.indexOf(key) < 0) {
        // 非表示項目に含まれない場合
        displayKeys.push(key)
      }
    }
    group1.list_display_keys_work = displayKeys

  })
  const group1 = reactive({

    // ページ当たりの表示件数
    init_list_per_page_work: 0, // 初期時

    list_per_page_work: 0,
    list_per_page: computed({
      get: () => {
        return group1.list_per_page_work
      },
      set: (listPerPage) => {
        group1.list_per_page_work = listPerPage
      }
    }),

    // 一覧画面の表示項目
    list_display_keys_work: [],
    list_display_keys: computed({
      get: () => {
        return group1.list_display_keys_work
      },
      set: (listDisplayKeys) => {
        group1.list_display_keys_work = listDisplayKeys
      }
    }),
    
    // 非表示にできる項目の値のリスト
    hideableKeys: ['text', 'current', 'note', 'format', 'book'],

    // 表示件数の選択肢表示フラグ
    visibleSelect: false,

    /**
     * 設定ボタン押下時
     */
    submit: () => {

      const hiddenKeys = []
      for (let i = 0; i < group1.hideableKeys.length; i++) {
        let isFound = false
        for (let k = 0; k < group1.list_display_keys_work.length; k++) {
          if (group1.list_display_keys_work[k] === group1.hideableKeys[i]) {
            isFound = true
            break
          }
        }
        if (!isFound) {
          // チェックボックスがチェックされていなかった場合
          hiddenKeys.push(group1.hideableKeys[i])
        }
      }

      // ストアに保存
      store.dispatch('qa/setListDisplaySettings', { perPage: group1.list_per_page_work, hiddenKeys: hiddenKeys })

      // 詳細画面から一覧画面に戻ってきた時のスクロール位置指定用IDをクリア
      store.dispatch('qa/setSelectedListItemId', 0)

      // コールバック
      const callback = () => {
        if (group1.init_list_per_page_work !== group1.list_per_page_work) {
          // ページ番号を1ページに設定する
          store.dispatch('qa/setPage', 1)
        }

        // 親画面の検索結果一覧を更新する
        context.parent.group1.updateSearchResultArea()

        // 本ウィンドウを閉じる
        context.emit('closeSearchDisplaySettings')
      }
      // 表示設定、並び順設定を保存する
      store.dispatch('qa/saveListSettings', { callback: callback })
    },

    /**
     * 閉じる
     */
    close: () => {
      group1.list_per_page_work = 0
      group1.list_display_keys_work = []
      context.emit('closeSearchDisplaySettings')
    }

  })

  return group1
}
